import ActionTypeItem from "../ActionTypeItem";
// import {ModosOp} from '../../Constantes'
// import Estado from '../EstadoDialogoClienteAFacturar'

export default class CargaDeErroresDelDominioAlActualizarItem extends ActionTypeItem {

    ejecutar(estado, nuevoEstado) {

        for (const property in nuevoEstado.error) {
            nuevoEstado.error[property]=false;
        }

        this.payload.errores.forEach( (error) => {
            nuevoEstado.error[error]=true;
        });

        nuevoEstado.flag.procesandoComando = false;
        return nuevoEstado;
    }

}